module.exports = __webpack_public_path__ + "img/l_d9.af3700be.png";